import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './styles';
import Button from '../Button';
import { FORMS, VIEWABLE_FORM_MODES } from '../../constants';

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    actionsRow: PropTypes.string,
  }).isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      component: PropTypes.func,
      props: PropTypes.object,
      validate: PropTypes.arrayOf(PropTypes.func),
    }),
  ).isRequired,
  isDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  buttonText: PropTypes.string,
  formMode: PropTypes.oneOf([
    VIEWABLE_FORM_MODES.EDITING,
    VIEWABLE_FORM_MODES.VIEWING,
  ]),
  initialValues: PropTypes.shape({}),
};

export const JobForm = props => {
  const {
    handleSubmit,
    classes,
    fields,
    isDisabled,
    isSubmitting,
    buttonText,
    formMode,
    initialValues,
  } = props;

  const renderButton = () => (
    <div className={classes.nextButton}>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        disabled={isDisabled}
      >
        {isSubmitting && <CircularProgress size={20} />}
        {!isSubmitting && buttonText}
      </Button>
    </div>
  );

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.inner}>
        <div className={classes.leftPanel}>
          <div className={classes.leftPanelContent}>
            {fields.map(
              field =>
                field.panel === 'left' && (
                  <div className={classes.formGroup} key={field.name}>
                    <Field
                      name={field.name}
                      component={field.component}
                      props={field.props}
                      validate={field.validate}
                      isEditing={formMode === VIEWABLE_FORM_MODES.EDITING}
                      initialValue={initialValues[field.name]}
                    />
                  </div>
                ),
            )}
          </div>
        </div>
        <div className={classes.rightPanel}>
          <div className={classes.rightPanelContent}>
            {fields.map(
              field =>
                field.panel === 'right' && (
                  <div className={classes.formGroup} key={field.name}>
                    <Field
                      name={field.name}
                      component={field.component}
                      props={field.props}
                      validate={field.validate}
                      isEditing={formMode === VIEWABLE_FORM_MODES.EDITING}
                      initialValue={initialValues[field.name]}
                    />
                  </div>
                ),
            )}
          </div>
        </div>
      </div>

      <div className={classes.actionsRow}>
        {formMode === VIEWABLE_FORM_MODES.EDITING && renderButton()}
      </div>
    </form>
  );
};

JobForm.propTypes = propTypes;

export default reduxForm({
  form: FORMS.JOB_FORM,
})(withStyles(styles)(JobForm));
